import Image, { StaticImageData } from "next/image";
import { useLocale } from "next-intl";
import {
    THAirPlanFlyingFruits,
    THAnagram,
    THCompleteTheSentence,
    THFindTheMatch,
    THFlappyBird,
    THFlipCards,
    THGameshowQuiz,
    THSituation,
    THWhackAMole,
    ENAirPlanFlyingFruits,
    ENAnagram,
    ENCompleteTheSentence,
    ENFindTheMatch,
    ENFlappyBird,
    ENFlipCards,
    ENGameshowQuiz,
    ENSituation,
    ENWhackAMole,
} from "../../assets";

type GameCard = {
    key: string;
    title: string;
    thImage: StaticImageData;
    enImage: StaticImageData;
};

type CreateGameProps = {
    onSelectTemplate: (title: string) => void;
};

const gameCards: GameCard[] = [
    {
        key: "find-the-match",
        title: "Find the match",
        thImage: THFindTheMatch,
        enImage: ENFindTheMatch,
    },
    {
        key: "gameshow-quiz",
        title: "Game show Quiz",
        thImage: THGameshowQuiz,
        enImage: ENGameshowQuiz,
    },
    {
        key: "flip-cards",
        title: "Flip cards",
        thImage: THFlipCards,
        enImage: ENFlipCards,
    },
    {
        key: "airplan-flying-fruits",
        title: "Flying Fruits",
        thImage: THAirPlanFlyingFruits,
        enImage: ENAirPlanFlyingFruits,
    },
    {
        key: "flappy-bird",
        title: "Flappy Chicken",
        thImage: THFlappyBird,
        enImage: ENFlappyBird,
    },
    {
        key: "whack-a-mole",
        title: "Whack a mole",
        thImage: THWhackAMole,
        enImage: ENWhackAMole,
    },
    {
        key: "anagram",
        title: "Anagram",
        thImage: THAnagram,
        enImage: ENAnagram,
    },
    {
        key: "complete-the-sentence",
        title: "Complete the Sentence",
        thImage: THCompleteTheSentence,
        enImage: ENCompleteTheSentence,
    },
    {
        key: "situation",
        title: "Situation",
        thImage: THSituation,
        enImage: ENSituation,
    },
];

export default function CreateGame({ onSelectTemplate }: CreateGameProps) {
    const locale = useLocale();
    const isThaiLocale = locale === "th";

    return (
        <div
            className="grid w-max max-w-full justify-start gap-x-5 gap-y-5 px-2 grid-cols-[repeat(2,minmax(0,13rem))] sm:grid-cols-[repeat(3,minmax(0,14rem))] md:grid-cols-[repeat(3,minmax(0,16rem))] lg:grid-cols-[repeat(3,minmax(0,26rem))]"
        >
            {gameCards.map((card) => {
                const image = isThaiLocale ? card.thImage : card.enImage;

                return (
                <button
                    key={card.key}
                    type="button"
                    onClick={() => onSelectTemplate(card.title)}
                    className="w-full cursor-pointer overflow-hidden rounded-lg"
                >
                    <Image
                        src={image}
                        alt={card.title}
                        width={image.width}
                        height={image.height}
                        className="h-auto w-full object-contain"
                        sizes="(max-width: 639px) 50vw, (max-width: 1023px) 34vw, (max-width: 1200px) 30vw, 480px"
                        quality={100}
                    />
                </button>
            )})}
        </div>
    );
}
